import { isString } from "../utils/isString";

/**.
 * Checks if the environment is "na" or "apac" for MyEROAD and "na" or "usc" for Phoenix.
 * Returns false otherwise.
 */
function isProductionEnv(): boolean {
  const environment = process.env.REACT_APP_ENVIRONMENT;
  if (!isString(environment)) {
    return false;
  }

  if (process.env.REACT_APP_PRODUCT === "coretex") {
    return ["na", "usc"].includes(environment);
  }

  if (process.env.REACT_APP_PRODUCT === "eroad") {
    return ["apac", "na"].includes(environment);
  }

  return false;
}

export { isProductionEnv };
